/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    // 'https://cdn.shopify.com/s/files/1/0553/8552/2309/files/20251023-p1.png',

    // 'https://cdn.shopify.com/s/files/1/0553/8552/2309/files/20251023-b1.png',
    // 'https://cdn.shopify.com/s/files/1/0553/8552/2309/files/20251023-b2.png',
    
    'https://cdn.shopify.com/s/files/1/0614/8607/1886/files/xia_59b409a2-a69c-44dd-849a-a376c136b89f.jpg?v=1767868155',
    'https://horainbow.com/cdn/shop/files/screenshot_2025-11-09_13-48-16_09fed0bb-0c57-4ac0-95bd-7d36c128f0ac.png?v=1765180207&width=600',
    'https://cdn.shopify.com/s/files/1/0614/8607/1886/files/lR3PD2vq5IF90cPNAXbNAiaww9jXTazA38cJRu30kkBBAA_550_374_3406e8e3-43b9-464e-ba29-5e94e9eaba08.jpg?v=1768816345'
    // 'https://cdn.shopify.com/s/files/1/0614/8607/1886/files/692215b2d54e70a0a8821d7de6006639_60ade432-1570-47a9-88ba-4fd8b7248a24.jpg?v=1767868155',
  ]

  new Swiper('.sp-swiper', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-pagination1',
      type: 'bullets',
      clickable: true,
    },
    loop: true,
    spaceBetween: 20,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight = $('.time-part').height() + $('.sp-header-top').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom') +
            10,
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let prods = window.product

  let sp_price1 = prods[0].price / 100000
  let sp_price2 = prods[0].compare_at_price / 100000

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(3)
  }

  function showTip() {
    let result = $('.product-part1 #sp_price1').html()

    if (result >= 29) {
      $('.product-part1 .sp-btn-style').addClass('sp-free-btn')
    } else {
      $('.product-part1 .sp-btn-style').removeClass('sp-free-btn')
    }
  }
  function showTip2() {
    let result = $('.sp-mask #sp_price3').html()

    if (result >= 29) {
      $('.sp-mask .sp-btn-style').addClass('sp-free-btn')
    } else {
      $('.sp-mask .sp-btn-style').removeClass('sp-free-btn')
    }
  }

  // $('.product-part1 .sp-reduce').click(function () {
  //   let input = $(this).siblings('input')[0]
  //   let num = Number(input.value) - 1
  //   if (num > 0) {
  //     input.value = num
  //   }
  //   const parentDom = $(this).closest('.sp-product-content')
  //   changePrice(parentDom)
  //   showTip()
  // })
  // $('.product-part1  .sp-add').click(function () {
  //   console.log('123')
  //   let input = $(this).siblings('input')[0]
  //   let num = Number(input.value) + 1
  //   input.value = num
  //   const parentDom = $(this).closest('.sp-product-content')
  //   changePrice(parentDom)
  //   showTip()
  // })

  $('.product-part1 .sp-btn-style').click(function () {
    // let num = $('.product-part1 #calcNumber').val()
    // let id = $(this).attr('data-id')
    // window.location.href = '/cart/' + id + ':' + num
  })
  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }
  function getCur(parentDom) {
    let color = parentDom.find('#sp-color div.active').attr('data-val')
    return prods.filter(
      item =>
        item.option1 == color
    )[0]
  }
  function changePrice(parentDom) {
    let num = parentDom.find('#calcNumber').val()
    let price = ((getCur(parentDom).price * num) / 100000).toFixed(3)
    let compare = ((getCur(parentDom).compare_at_price * num) / 100000).toFixed(3)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    parentDom.find('.price1 span').html(price)
    parentDom.find('.price2 span').html(compare)
    // let off_font =
    //   100 - Math.ceil((getCur(parentDom).price / getCur(parentDom).compare_at_price) * 100)
    // parentDom.find('.price-group .sp-row span').html(off_font)
  }

  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      const parentDom = $(this).closest('.sp-product-content')
      changePrice(parentDom)
    }
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    const parentDom = $(this).closest('.sp-product-content')
    changePrice(parentDom)
  })
  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    const parentDom = $(this).closest('.sp-product-content')
    let colorOptions = parentDom.find('#sp-color .sp-option.active').index()

    const index = colorOptions
    parentDom.find('.sp-img-wrap img')[0].src = spImgList[index]
    changePrice(parentDom)
  })

  $('.sp-btn-style').click(function () {
    const parentDom = $(this).closest('.sp-product-content')
    let num = parentDom.find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(parentDom).id + ':' + num
  })
  // $('.sp-mask .sp-reduce').click(function () {
  //   let input = $(this).siblings('input')[0]
  //   let num = Number(input.value) - 1

  //   if (num > 0) {
  //     input.value = num
  //   }

  //   const parentDom = $(this).closest('.sp-product-content')
  //   changePrice(parentDom)
  //   showTip2()
  // })
  // $('.sp-mask .sp-add').click(function () {
  //   let input = $(this).siblings('input')[0]
  //   let num = Number(input.value) + 1

  //   input.value = num
  //   const parentDom = $(this).closest('.sp-product-content')
  //   changePrice(parentDom)
  //   showTip2()
  // })
  $('.sp-mask .sp-btn-style').click(function () {
    // let num = $('.sp-mask #calcNumber').val()
    // let id = $(this).attr('data-id')
    // window.location.href = '/cart/' + id + ':' + num
  })

  // 展示尺码弹窗
  $('.sp-btn-pop').click(function () {
    $('.sp-mask').css('display', 'flex')
    // $(".sp-pop").show();
  })
  // 关闭弹窗按钮

  $('.sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    // $(".sp-pop").hide();
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
